import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit, OnChanges, ChangeDetectorRef } from '@angular/core';
import { getInvalidFields, markFormGroupTouched } from '../../functions/shared-functions';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'tm-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit, OnChanges {
  @Input() form_group: UntypedFormGroup;
  @Input() form_control
  @Input() data
  @Input() label;
  @Input() placeholder;
  @Input() masters;
  expended: boolean = false;

  educationLevelList = [{
    id: 1,
    title: "UG or below"
  },
  {
    id: 2,
    title: "Post graduate"
  },
  {
    id: 3,
    title: "PhD"
  }]

  percentageTypeList = [{
    id: 1,
    title: "%"
  }, {
    id: 2,
    title: 'CGPA'
  }]
  educationTypeList = [{
    id: 1,
    title: "Full time"
  },
  {
    id: 2,
    title: "Part time"
  },]
  educationList = []

  educationForm: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl('',),
    yop: new UntypedFormControl('', [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(6),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),


  })
  educationForm2: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl('',),
    yop: new UntypedFormControl('', [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(1),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),

  })
  educationForm3: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl('',),
    yop: new UntypedFormControl('', [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(1),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),

  })
  current_education: any = {};
  current_education2: any = {};
  current_education3: any = {};
  constructor(
    private notification: NotificationService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

  }
  ngOnChanges(ev) {
    console.log(ev)
    if (ev && ev.masters) {
      this.masters = ev.masters.currentValue
    }
    if (ev && ev.data) {
      console.log(ev.data.currentValue)
      this.educationList = ev.data.currentValue;
      if (this.educationList && this.educationList.length) {
        for (let i = 0; i < this.educationList.length; i++) {
          let item = this.educationList[i];
          if (i == 0) {
            this.educationForm.patchValue(item);
          }
          else if (i == 1) {
            this.educationForm2.patchValue(item)
          }
          else if (i == 2) {
            this.educationForm3.patchValue(item)
          }
        }
      }
    }
  }
  changeEducation(ev, type?) {
    if (!type) {
      this.current_education = ev;
      if (ev) {
        this.educationForm.controls.educationTitle.patchValue(ev.title)
        if (ev.isPassing) {
          this.educationForm.controls.mop.setValidators([Validators.required])
          this.educationForm.controls.mop.updateValueAndValidity();
          this.educationForm.controls.yop.setValidators([Validators.required])
          this.educationForm.controls.yop.updateValueAndValidity();
        }
        else {
          this.educationForm.controls.mop.clearValidators();
          this.educationForm.controls.yop.clearValidators();
          this.educationForm.controls.mop.updateValueAndValidity();
          this.educationForm.controls.yop.updateValueAndValidity();

        }

        if (ev.isPercentage) {
          this.educationForm.controls.percentage.setValidators([Validators.required]);
          this.educationForm.controls.percentage.updateValueAndValidity();
        }
        else {
          this.educationForm.controls.percentage.clearValidators();
          this.educationForm.controls.percentage.updateValueAndValidity();

        }
        if (ev.isSpecialization) {
          this.educationForm.controls.specializationCode.setValidators([Validators.required]);
          this.educationForm.controls.specializationCode.updateValueAndValidity();
        }
        else {
          this.educationForm.controls.specializationCode.clearValidators();
          this.educationForm.controls.specializationCode.updateValueAndValidity();
        }
        if (ev.noSpecialization) {

          this.educationForm.controls.specializationCode.clearValidators();
          this.educationForm.controls.specializationTitle.clearValidators();
          this.educationForm.controls.specializationTitle.patchValue(null)
          this.educationForm.controls.specializationCode.patchValue(null)
          this.educationForm.controls.specializationCode.updateValueAndValidity();
        }

        this.educationForm.updateValueAndValidity();
      }
    }
    else if (type == 2) {
      this.current_education2 = ev;
      if (ev) {
        this.educationForm2.controls.educationTitle.patchValue(ev.title)
        if (ev.isPassing) {
          this.educationForm2.controls.mop.setValidators([Validators.required])
          this.educationForm2.controls.mop.updateValueAndValidity();
          this.educationForm2.controls.yop.setValidators([Validators.required])
          this.educationForm2.controls.yop.updateValueAndValidity();
        }
        else {
          this.educationForm2.controls.mop.clearValidators();
          this.educationForm2.controls.yop.clearValidators();
          this.educationForm2.controls.mop.updateValueAndValidity();
          this.educationForm2.controls.yop.updateValueAndValidity();

        }

        if (ev.isPercentage) {
          this.educationForm2.controls.percentage.setValidators([Validators.required]);
          this.educationForm2.controls.percentage.updateValueAndValidity();
        }
        else {
          this.educationForm2.controls.percentage.clearValidators();
          this.educationForm2.controls.percentage.updateValueAndValidity();

        }
        if (ev.isSpecialization) {
          this.educationForm2.controls.specializationCode.setValidators([Validators.required]);
          this.educationForm2.controls.specializationCode.updateValueAndValidity();
        }
        else {
          this.educationForm2.controls.specializationCode.clearValidators();
          this.educationForm2.controls.specializationCode.updateValueAndValidity();
        }
        if (ev.noSpecialization) {

          this.educationForm2.controls.specializationCode.clearValidators();
          this.educationForm2.controls.specializationTitle.clearValidators();
          this.educationForm2.controls.specializationTitle.patchValue(null)
          this.educationForm2.controls.specializationCode.patchValue(null)
          this.educationForm2.controls.specializationCode.updateValueAndValidity();
        }

        this.educationForm2.updateValueAndValidity();
      }
    }
    else if (type == 3) {
      this.current_education3 = ev;
      if (ev) {
        this.educationForm3.controls.educationTitle.patchValue(ev.title)
        if (ev.isPassing) {
          this.educationForm3.controls.mop.setValidators([Validators.required])
          this.educationForm3.controls.mop.updateValueAndValidity();
          this.educationForm3.controls.yop.setValidators([Validators.required])
          this.educationForm3.controls.yop.updateValueAndValidity();
        }
        else {
          this.educationForm3.controls.mop.clearValidators();
          this.educationForm3.controls.yop.clearValidators();
          this.educationForm3.controls.mop.updateValueAndValidity();
          this.educationForm3.controls.yop.updateValueAndValidity();

        }

        if (ev.isPercentage) {
          this.educationForm3.controls.percentage.setValidators([Validators.required]);
          this.educationForm3.controls.percentage.updateValueAndValidity();
        }
        else {
          this.educationForm3.controls.percentage.clearValidators();
          this.educationForm3.controls.percentage.updateValueAndValidity();

        }
        if (ev.isSpecialization) {
          this.educationForm3.controls.specializationCode.setValidators([Validators.required]);
          this.educationForm3.controls.specializationCode.updateValueAndValidity();
        }
        else {
          this.educationForm3.controls.specializationCode.clearValidators();
          this.educationForm3.controls.specializationCode.updateValueAndValidity();
        }
        if (ev.noSpecialization) {

          this.educationForm3.controls.specializationCode.clearValidators();
          this.educationForm3.controls.specializationTitle.clearValidators();
          this.educationForm3.controls.specializationTitle.patchValue(null)
          this.educationForm3.controls.specializationCode.patchValue(null)
          this.educationForm3.controls.specializationCode.updateValueAndValidity();
        }

        this.educationForm3.updateValueAndValidity();
      }
    }

  }
  specialicationChanged(ev, type?) {
    if (!type) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }
    else if (type == 2) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }
    else if (type == 3) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }

  }
  addEducation() {
    if (this.educationForm.valid) {
      let education = this.form_group.get([this.form_control]).value;
      if (typeof education == "string") {
        try {
          education = JSON.parse(education);
          if (education && education.length) {
            let index = education.findIndex(data => data.educationCode == this.educationForm.value.educationCode);
            if (index > -1) {
              education[index] = this.educationForm.value;
            }
            else {
              education.push(this.educationForm.value);
            }
          }
          else {
            education = []
            education.push(this.educationForm.value);
          }
        }
        catch (err) {
          education = []
        }
      } else {
        if (education && education.length) {
          let index = education.findIndex(data => data.educationCode == this.educationForm.value.educationCode);
          if (index > -1) {
            education[index] = this.educationForm.value;
          }
          else {
            education.push(this.educationForm.value);
          }
        }
        else {
          education = []
          education.push(this.educationForm.value);
        }
      }
      this.form_group.get([this.form_control]).patchValue(education);
      this.educationForm.reset();

    }
    else {
      markFormGroupTouched(this.educationForm);
      getInvalidFields(this.educationForm, this.translate, this.notification, 'RESUME.');
    }

  }

  deleteEducation(i) {

    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'CONFIRMATION.are_you_sure_to_delete',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        let education = this.form_group.get([this.form_control]).value;
        try {
          if (education && education.length) {
            education.splice(i, 1);
          }
        }
        catch (err) {
          console.log(err)
        }
        this.form_group.get([this.form_control]).patchValue(education)
      }
    })

  }


  editEducation(index) {
    this.educationForm.reset();
    let education = this.form_group.get([this.form_control]).value;
    try {
      this.educationForm.patchValue(education[index]);
      if (education && education.length) {
        education.splice(index, 1);
      }
    }
    catch (err) {
      console.log(err)
    }
    this.form_group.get([this.form_control]).patchValue(education)
  }
  panelEvent(ev, panel: MatExpansionPanel) {
    this.expended = true;
    this.change_detector.detectChanges();
    setTimeout(() => {
      this.expended = false;
    }, 500)
  }
  panelClosure(ev, panel) {
    if (this.expended) {
      setTimeout(() => {
        panel.open()
      })
    }

    if (this.educationForm.value.educationLevel == 6) {
      this.educationList = [this.educationForm.value]
    }
    else if (this.educationForm.value.educationLevel == 7) {
      this.educationList = [this.educationForm.value]
      this.educationList.push(this.educationForm2.value)

    }
    else if (this.educationForm.value.educationLevel == 8) {
      this.educationList = [this.educationForm.value]
      this.educationList.push(this.educationForm2.value)
      this.educationList.push(this.educationForm3.value)

    }

    this.form_group.get([this.form_control]).patchValue(this.educationList)
  }
  saveChanges(panel) {

    if (this.educationForm.value.educationLevel == 6) {
      this.educationList = [this.educationForm.value]
    }
    else if (this.educationForm.value.educationLevel == 7) {
      this.educationList = [this.educationForm.value]
      this.educationList.push(this.educationForm2.value)

    }
    else if (this.educationForm.value.educationLevel == 8) {
      this.educationList = [this.educationForm.value]
      this.educationList.push(this.educationForm2.value)
      this.educationList.push(this.educationForm3.value)

    }

    this.form_group.get([this.form_control]).patchValue(this.educationList)
    if (panel) {
      setTimeout(() => {
        panel.close()
      })
    }
  }
}
